import React from "react";
import PageHeader from "../PageHeader";
import heroBackImage from "../images/hero/hero.webp";
import "../css/legal.css";

const PolicyPage = () => {
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "سياسة الاستخدام والخصوصية", path: "/policy" },
  ];

  return (
    <>
      <PageHeader
        title="سياسة الاستخدام والخصوصية"
        bgImage={heroBackImage}
        breadcrumbs={breadcrumbLinks}
      />

      <section className="legal-section">
        <div className="container">
          <div className="legal-wrapper">
            <p className="legal-intro">
              تهدف هذه السياسة إلى توضيح كيفية استخدامك لموقع نبض كير والخدمات
              المقدمة من خلاله، بالإضافة إلى توضيح كيفية تعاملنا مع بياناتك
              الشخصية وحمايتها بما يتوافق مع الأنظمة المعمول بها في المملكة
              العربية السعودية.
            </p>

            <div className="legal-block">
              <h2 className="legal-block-title">أولاً: نطاق التطبيق</h2>
              <p>
                تنطبق هذه السياسة على جميع زوار موقع نبض كير والعملاء
                المستخدمين لخدماتنا الاستشارية، سواء تم التواصل عبر الموقع أو
                عبر قنوات الاتصال الأخرى المرتبطة به.
              </p>
              <p>
                باستخدامك للموقع فإنك تقر بأنك قرأت هذه السياسة وفهمتها
                وتوافق على الالتزام بما ورد فيها من شروط وأحكام.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">ثانياً: استخدام الموقع</h2>
              <ul className="legal-list">
                <li>تتعهّد باستخدام الموقع لأغراض مشروعة تتوافق مع الأنظمة.</li>
                <li>
                  تلتزم بعدم إساءة استخدام أي من الخدمات أو محاولة الدخول غير
                  المصرح به لأي جزء من أنظمة نبض كير.
                </li>
                <li>
                  أي معلومات تقوم بإرسالها عبر النماذج الموجودة في الموقع يجب أن
                  تكون صحيحة ودقيقة وحديثة.
                </li>
              </ul>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">ثالثاً: البيانات التي نقوم بجمعها</h2>
              <p>قد نقوم في نبض كير بجمع أنواع مختلفة من البيانات، مثل:</p>
              <ul className="legal-list">
                <li>بيانات الاتصال الأساسية مثل الاسم، رقم الجوال، والبريد الإلكتروني.</li>
                <li>بيانات تتعلق بنشاطك التجاري أو مشروعك لغايات تقديم الاستشارة.</li>
                <li>بيانات تقنية عامة مثل عنوان بروتوكول الإنترنت ونوع المتصفح.</li>
              </ul>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">رابعاً: كيفية استخدام البيانات</h2>
              <p>نستخدم بياناتك للأغراض التالية:</p>
              <ul className="legal-list">
                <li>الرد على استفساراتك وتقديم العروض والخدمات الاستشارية المناسبة.</li>
                <li>تحسين تجربة استخدام الموقع وتطوير الخدمات.</li>
                <li>الالتزام بالمتطلبات النظامية والرقابية عند اللزوم.</li>
              </ul>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">خامساً: حماية الخصوصية</h2>
              <p>
                نحرص في نبض كير على حماية سرية بياناتك وعدم مشاركتها مع أي طرف
                ثالث إلا في الحالات التي يتطلبها تقديم الخدمة أو بموجب التزامات
                نظامية.
              </p>
              <p>
                نتخذ إجراءات معقولة لحماية البيانات من الوصول غير المصرح به أو
                الضياع أو التعديل، مع إدراك أن أي نقل للبيانات عبر الإنترنت لا
                يمكن أن يكون آمناً بنسبة 100%.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">سادساً: حقوقك تجاه بياناتك</h2>
              <ul className="legal-list">
                <li>يحق لك طلب تصحيح أي بيانات شخصية غير دقيقة لديك لدينا.</li>
                <li>يحق لك طلب إيقاف استخدام بياناتك التسويقية في أي وقت.</li>
                <li>
                  يمكنك التواصل معنا لطرح أي استفسار متعلق بخصوصيتك من خلال
                  بيانات الاتصال الموضحة في الموقع.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PolicyPage;

